<template>
  <a href="#" @click="handleClick" class="resource-holder">
    <span>
      <file-icon
        v-if="resourceObject.name"
        :type="resourceObject.name | extension"
      ></file-icon>
      <file-icon v-else type="link"></file-icon>
    </span>
    <span class="title">{{ title || resourceTitle }}</span>
    <div v-if="resourceObject.type !== 'page'" class="resource-holder__icon">
      <icon width="18" height="18" icon="download"></icon>
    </div>
    <div v-else class="resource-holder__icon">
      <icon width="18" height="18" icon="arrow"></icon>
    </div>
  </a>
</template>

<script>
export default {
  name: "media-file",

  props: {
    fileLink: String,
    fileId: [Number, String],
    title: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      resourceTitle: "",
      resourceId: "",
      resourceObject: {},
      resourceInfo: {},
    };
  },

  watch: {
    fileLink: {
      immediate: true,
      handler: "getFileInfo",
    },
  },

  created() {
    const { fileLink, title, $store } = this;
    if (this.fileId) {
      this.$store.dispatch("files/read", this.fileId).then((resp) => {
        const fileLinkClone = {
          id: resp.self,
          name: resp.name,
          documentId: resp.id,
          type: "file",
        };
        //   const fileLinkClone = {"id":"file/14","name":"Consultant Study & Proffesional Leave Form.doc","documentId":14,"type":"file"}
        this.resourceObject = fileLinkClone;
        this.resourceTitle = title ? title : this.resourceObject.name;

        console.log("rsp", this.resourceTitle);
      });
    } else if (fileLink) {
      this.resourceObject = JSON.parse(fileLink);
      this.resourceTitle = title || this.resourceObject.name;
    } else {
      this.resourceObject = {};
      this.resourceTitle = "";
    }
  },

  methods: {
    getFileInfo(data) {
      //   obj = JSON.parse(data);
      //   this.resourceId = obj.id.split("/")[1];
      //   // If we are a form or policy we need to get info about the file
      //   if (this.resourceObject.type !== "page") {
      //     this.$store.dispatch("files/read", this.resourceId).then(resp => {
      //       this.resourceInfo = resp;
      //     });
    },
    /**
     * Depending on the type of object we are linking
     * Policy / Form needs to read the file API
     * Content -> needs to just link to content
     */
    handleClick(e) {
      e.preventDefault();
      if (this.$route.meta.isAdmin) {
        return true;
      }
      let ready = false;
      const { $store, resourceObject, $router, resourceInfo } = this;

      const obj = resourceObject;
      let resourceId;
      //backwards compat
      if (obj.id.toString().indexOf("/") >= 0) {
        resourceId = obj.id.split("/")[1];
      } else {
        resourceId = obj.self.split("/")[1];
      }

      this.$store.dispatch("files/read", resourceId).then((resp) => {
        this.$store.dispatch("files/download", resp).catch((err) => {
          this.$store.dispatch(
            "notifications/create",
            {
              body: `There was a problem downloading the file`,
              type: "danger",
            },
            { root: true }
          );
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.resource-holder {
  border-bottom: 1px solid $colour-nhs-pale-grey;
  display: inline-flex;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  text-decoration: none;
  transition: box-shadow 0.2s ease;
  position: relative;
  width: 100%;
  flex-direction: column;
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  line-height: 1;

  .c-file-icon {
    margin-right: 10px;
  }

  span {
    flex: 1;
    text-align: center;
    margin: 20px 0;
    @media (min-width: 1024px) {
      margin: 0;
    }

    &.title {
      flex: 10;
      text-align: left;
    }
  }

  &:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    cursor: pointer;

    .resource-holder__icon {
      svg {
        fill: $colour-nhs-core-blue;
      }
    }
  }

  &__icon {
    width: 100%;
    border: none;
    text-align: center;
    padding: 0;
    margin: 0 0 20px;
    @media (min-width: 1024px) {
      align-self: center;
      border-left: 1px solid $colour-nhs-pale-grey;
      padding: 25px 25px 20px;
      margin: 0;
    }
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    align-content: center;

    svg {
      fill: $colour-nhs-mid-grey;
      transition: fill 0.2s ease;
      transform: scale(1.25);
    }
  }
}
</style>
